import { Rest } from '@abp/ng.core';
import { Injectable, inject } from '@angular/core';
import { ZnSelectQueryParams } from '@zendra/shared';
import { StandPartitionPlanningOrchestratorService } from 'orchestrator';
import type {
  FinalizeStandPartitionInputDto,
  FinalizeStandPartitionOutputDto,
  StandPartitionStandDetailDto,
} from 'orchestrator';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class StandPartitionPlanningService {
  private readonly orchestratorService = inject(StandPartitionPlanningOrchestratorService);

  searchStandOptions(
    params?: ZnSelectQueryParams,
    config?: Partial<Rest.Config>,
  ): Observable<{ items: { key: string; value: string }[]; totalCount: number }> {
    return this.orchestratorService.searchStands(
      {
        filter: params?.search,
        skipCount: params?.skipCount,
        maxResultCount: params?.maxResultCount,
      },
      config,
    ).pipe(
      map(response => ({
        items: response.items.map(item => ({
          key: String(item.id),
          value: item.name ?? String(item.id),
        })),
        totalCount: response.totalCount,
      })),
    );
  }

  getStandDetail(
    standId: number,
    config?: Partial<Rest.Config>,
  ): Observable<StandPartitionStandDetailDto> {
    return this.orchestratorService.getStandDetail(standId, config);
  }

  ensureCanAdvance(
    standId: number,
    config?: Partial<Rest.Config>,
  ): Observable<void> {
    return this.orchestratorService.ensureCanAdvance(standId, config);
  }

  ensureAreaMaintenancePeriodAvailable(
    standId: number,
    periodId: number,
    config?: Partial<Rest.Config>,
  ): Observable<void> {
    return this.orchestratorService.ensureAreaMaintenancePeriodAvailable(
      standId,
      periodId,
      config,
    );
  }

  finalize(
    input: FinalizeStandPartitionInputDto,
    config?: Partial<Rest.Config>,
  ): Observable<FinalizeStandPartitionOutputDto> {
    return this.orchestratorService.finalize(input, config);
  }
}
